/**
 * Onboarding API Module
 * Server-side onboarding state, invite management
 */

import { api } from './client'

export const onboardingAPI = {
  // ── User endpoints ────────────────────────────────────────────────────────

  /** Fetch the current user's onboarding state (track + completedSteps) */
  getMyState: () =>
    api.get('/profile/onboarding', { silentAuth: true, noRetry: true }),

  /** Merge client-side completed steps into the server record */
  patchSteps: (steps) =>
    api.patch('/profile/onboarding/steps', { steps }),

  // ── Invite endpoints (public + auth) ─────────────────────────────────────

  /** Validate an invite token (public — used on /register?invite=<token>) */
  validateInvite: (token) =>
    api.get(`/invites/${token}`, { silentError: true }),

  /** Accept an invite after successful registration */
  acceptInvite: (token) =>
    api.post(`/invites/${token}/accept`),

  // ── Admin endpoints ───────────────────────────────────────────────────────

  /** Get onboarding state for any user */
  adminGetUserState: (userId) =>
    api.get(`/admin/users/${userId}/onboarding`),

  /**
   * Overwrite a user's onboarding track and/or completed steps.
   * @param {string} userId
   * @param {{ track?: string, completedSteps?: Record<string,number>, adminNote?: string }} data
   */
  adminSetUserState: (userId, data) =>
    api.put(`/admin/users/${userId}/onboarding`, data),

  /** List all invites */
  adminListInvites: () =>
    api.get('/admin/invites'),

  /**
   * Send an invite email.
   * @param {{ email: string, track: 'visitor'|'vendor', message?: string }} data
   */
  adminSendInvite: (data) =>
    api.post('/admin/invites', data),

  /**
   * Update a pending invite.
   * @param {string} inviteId
   * @param {{ email?: string, track?: string, message?: string, entityId?: string, expiresInDays?: number }} data
   */
  adminUpdateInvite: (inviteId, data) =>
    api.put(`/admin/invites/${inviteId}`, data),

  /**
   * Revoke a pending invite.
   * @param {string} inviteId
   */
  adminRevokeInvite: (inviteId) =>
    api.delete(`/admin/invites/${inviteId}`),

}
